<!--
 * @Author: zhonghao
 * @Date: 2024-04-01 11:28:14
-->
<template>
  <div class="plan">
    <img v-for="(item, index) in details.planPics" class="img" :key="index" :src="item.url" alt="">
  </div>
</template>

<script>
import { signDetails } from '@/api/zone'
export default {
  data () {
    return {
      details: {},

    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    signDetails({
      areaId: this.$route.query.areaId
    }).then(res => {
      this.details = res.data
    })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>

.plan {
  .img{
    display: block;
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/plan.vue